'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthBitHeader = require('@narvar/nth-bit-header');
var Checkbox = require('@narvar/nth-block-checkbox');
var TextInput = require('@narvar/nth-block-text-input');
var React = require('react');
var StyledThemeProvider = require('../../../providers/StyledThemeProvider.js');
var styles = require('./styles.js');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/index.js');
require('../../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/index.js');
require('../../../components/PudoCard/index.js');
require('../../../components/ItemCard/index.js');
require('../../../components/SelectItem/index.js');
require('../../../components/SelectList/index.js');
require('../../../components/ErrorBanner/index.js');
require('../../../components/Footer/index.js');
require('../../../components/StickyFooter/index.js');
require('../../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/index.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/ItemCardSkeleton.js');
require('../../../components/Skeleton/LineItemSkeleton.js');
require('../../../components/Skeleton/PudoCardSkeleton.js');
var useLanguage = require('../../../hooks/useLanguage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReshopOptIn = _ref => {
  let {
    value,
    error,
    onChange
  } = _ref;
  const {
    subscribe = false,
    phone = ''
  } = value ?? {};
  const phoneLabel = useLanguage["default"]({
    langKey: 'returnsReviewReshopPhoneInputLabel'
  }).value;
  const handleSubscribeChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      subscribe: event.target.checked,
      phone
    });
  };
  const handlePhoneChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      subscribe,
      phone: event.target.value
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(styles.Wrapper, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewReshopTitle"
  })), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "reshopSubscribeSmsUpdates",
    checked: subscribe,
    labelBoxCellStyle: {
      background: '#fff'
    },
    onChange: handleSubscribeChange
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewReshopCheckboxLabel"
  }))), subscribe && /*#__PURE__*/React__default["default"].createElement(styles.FormField, null, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: "reshopCustomerPhone",
    type: TextInput.SupportedInputType.tel,
    label: phoneLabel,
    animateLabel: true,
    containerOverridesStyle: {
      background: '#fff'
    },
    error: !!error,
    value: phone,
    onChange: handlePhoneChange
  }), error && /*#__PURE__*/React__default["default"].createElement(styles.ErrorMessage, null, error)), /*#__PURE__*/React__default["default"].createElement(styles.Disclaimer, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReviewReshopDisclaimer"
  })));
};
var ReshopOptIn$1 = StyledThemeProvider.withStyledThemeProvider(ReshopOptIn, {
  themeTokens: ['panelcontainerNoneNone', 'captiontextDefaultNone', 'captiontextErrorNone']
});

exports["default"] = ReshopOptIn$1;
